var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetabolicProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F8BA33",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 75.5,
    r: 75.5,
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.088 52.127c-8.814-8.813-22.862-9.542-32.54-1.688-9.802-7.91-24.025-7.017-32.759 2.058-8.734 9.075-9.083 23.321-.803 32.813.185.307.43.573.721.783l.343.36 28.76 28.76a5.277 5.277 0 0 0 7.466 0l28.812-28.733c9.447-9.503 9.447-24.85 0-34.353zm-3.773 30.624l-28.768 28.767L49.65 86.612h1.76c.942 0 1.814-.503 2.286-1.32l7.097-12.312 6.156 18.732a2.638 2.638 0 0 0 2.243 1.76h.255c.95 0 1.827-.511 2.296-1.337l7.449-13.192 3.729 6.367a2.638 2.638 0 0 0 2.278 1.302h7.862a2.638 2.638 0 0 0 0-5.277h-6.359l-5.276-8.945a2.586 2.586 0 0 0-2.296-1.301 2.638 2.638 0 0 0-2.278 1.337L70.15 84.378l-6.157-18.68a2.638 2.638 0 0 0-4.793-.493l-9.331 16.13h-5.365c-6.418-7.839-5.563-19.333 1.943-26.136 7.507-6.803 19.03-6.525 26.2.63a2.638 2.638 0 0 0 1.865.775c.7 0 1.37-.28 1.864-.774 7.434-7.439 19.491-7.443 26.93-.009 7.439 7.434 7.443 19.49.009 26.93z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetabolicProfile);
export default __webpack_public_path__ + "static/media/metabolic-profile.8f2942772e15a563610efbf05f82a065.svg";
export { ForwardRef as ReactComponent };